import {Box, Paper, Accordion, AccordionDetails, AccordionSummary, useTheme,} from "@mui/material";
import React, {useEffect, useRef, useState} from "react";
import {useGroup} from "../contexts/GroupContext";
import {firestore, storage} from "../firebase";
import LoadingComponent from "../pages/LoadingComponent";
import Typography from "@mui/material/Typography";
import MapButton from "./MapButton";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import NatureIcon from '@mui/icons-material/Nature';
import {makeStyles} from '@mui/styles';
import RefreshIcon from '@mui/icons-material/Refresh';
import IconButton from "@mui/material/IconButton";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    paper: {
        marginRight: theme.spacing(2),
    },
    box: {
        transform: 'translate(-50%,-50%)',
    },
    robotbox: {
        transform: 'translate(-50%,-25%)',
    },
    accordionDivider: {
        marginTop: theme.spacing(-2) + "!important",
        marginBottom: theme.spacing(2) + "!important"
    }
}));

const MapComponent = () => {

    const {group, locationDocs, videoNames, sendUserInput, botSerials, botNames, selectedBot} = useGroup()
    const [map, setMap] = useState()
    const [initialize, setInitialize] = useState(false)
    const [isReady, setIsReady] = useState(false)
    const [buttons, setButtons] = useState()
    const [width, setWidth] = useState(0)
    const [height, setHeight] = useState(0)
    const [originX, setOriginX] = useState(0)
    const [originY, setOriginY] = useState(0)
    const [mapResolution, setMapResolution] = useState(0)
    const [addingLocation, setAddingLocation] = useState(false)
    const [pendingLocation, setPendingLocation] = useState({})
    const [currentLocations, setCurrentLocations] = useState()
    const [locations, setLocations] = useState([])
    const [addInstructionsOpen, setAddInstructionsOpen] = useState(false)
    const [componentOpen, setComponentOpen] = useState(true)
    const classes = useStyles();
    const theme = useTheme()

    // const mapScrollRef = useRef(null);
    // const buttonScrollRef = useRef(null); //Used for scrolling components into view
    const mapImgRef = useRef(null);

    var startX=0.0;
    var startY=0.0;

    function handleAddLocation() {
        //Comment back in to restore auto scrolling functionality
        // if (mapScrollRef.current) {
        //     mapScrollRef.current.scrollIntoView({behavior: "smooth", block: "nearest", inline: "nearest"});
        // }
        setAddInstructionsOpen(true)
        setAddingLocation(true)
    }

    function handleCancelAddLocation() {
        setAddingLocation(false)
    }

    function handleCloseAddInstructions() {
        setAddInstructionsOpen(false)
    }

    function handleCancelAddInstructions() {
        setAddInstructionsOpen(false)
        setAddingLocation(false)
    }

    function handleSubmitAddLocation() {
        const locationName = document.getElementById('locationNameField').value.trim().toLowerCase();
        var regEx = /^[0-9a-zA-Z ]+$/;
        if(locationName.match(regEx)) {
            pendingLocation.name = locationName;
        } else {
            pendingLocation.name = '"' + locationName + '"';
        }

        if (pendingLocation.raw == null || pendingLocation.map == null) {
            alert("Error getting location coordinates, please try again");
        }

        if (/\S/.test(locationName)) {
            //Todo: Will: do we care about explicit confirmation?
            firestore.collection(`groups/${group}/navigation`).doc(pendingLocation.name).set(pendingLocation)
            handleCancelAddLocation();
        } else {
            alert("Please input a valid location name before saving!");
        }
    }

    var Small = {
        'zero': 0,
        'one': 1,
        'two': 2,
        'three': 3,
        'four': 4,
        'five': 5,
        'six': 6,
        'seven': 7,
        'eight': 8,
        'nine': 9,
        'ten': 10,
        'eleven': 11,
        'twelve': 12,
        'thirteen': 13,
        'fourteen': 14,
        'fifteen': 15,
        'sixteen': 16,
        'seventeen': 17,
        'eighteen': 18,
        'nineteen': 19,
        'twenty': 20,
        'thirty': 30,
        'forty': 40,
        'fifty': 50,
        'sixty': 60,
        'seventy': 70,
        'eighty': 80,
        'ninety': 90
    };

    const generateButton = (location, x, y) => {
        return (
            <Box className={classes.box} key={location} position="absolute" top={y + "%"} left={x + "%"}>
                <MapButton name={location} videos={videoNames}/>
            </Box>
        )
    }

    const fetchMapAndRobot = () => {
        fetchMap()
        // sendUserInput("Where are you")
    }
    //Gets map information from storage
    const fetchMap = () => {
        storage.ref(group + "/map.png").getDownloadURL().then((r) => {
            setMap(r)
            storage.ref(group + "/map.png").getMetadata().then((metadata) => {
                if (metadata.customMetadata === undefined) {
                    console.log("Map on firebase has no associated custom metadata - displaying sendmap alert")
                    setInitialize(true)
                    return
                } else {
                    setInitialize(false)
                }
                const width = parseFloat(metadata.customMetadata.width)
                setWidth(width)
                const height = parseFloat(metadata.customMetadata.height)
                setHeight(height)
                const originX = parseFloat(metadata.customMetadata.originX)
                setOriginX(originX)
                const originY = parseFloat(metadata.customMetadata.originY)
                setOriginY(originY)
                const mapResolution = parseFloat(metadata.customMetadata.resolution)
                setMapResolution(mapResolution)
                const buttons = []
                const locations = []
                locationDocs.forEach( doc => {
                    if (doc.data().map === undefined || doc.data().raw === undefined) {
                        console.log("location on firebase has missing data: " + doc.id);
                    } else {
                        let data = doc.data().map
                        let locName = doc.id
                        if (locName[0] === "\"" && locName[locName.length-1] === "\"") {
                            locName = locName.slice(1,-1)
                        }
                        locations.push(locName)
                        buttons.push(generateButton(locName, 100 * data.x / width, 100 * data.y / height))
                    }
                })

                //Sort location names based on numbers regardless of whether written out or not
                //Will only work for numbers 0 -> 99, with anything above 20 needing to be two words
                const locationMap = [];
                locations.forEach(loc => {
                    const numericLoc = [];
                    let tokenized = loc.split(" ");
                    tokenized.forEach(token => {
                        var x = Small[token];
                        if (x != null) {
                            numericLoc.push(x);
                        } else {
                            numericLoc.push(token);
                        }
                    })
                    locationMap.push({"base": loc, "numeric": numericLoc.join(" ")});
                });
                locationMap.sort(function(a,b) {
                    return a.numeric > b.numeric;
                })
               const sortedLocations = []
               locationMap.forEach(l => {
                sortedLocations.push(l.base);
               })
               setLocations(sortedLocations)

//                    setLocations(locations)
                setButtons(buttons)
            })
        }).catch(() => { //If the image doesn't exist, display the initialization message
            setInitialize(true)
        })
    }

    //Group effect to get the map and location data
    useEffect(() => {
        //Generates listeners on the robot's document for position changes
        let currentUnsubscriber;
        const generateCurrentLocationsListener = async () => {
            //Set the listener to dispatch on added message. Return unsubscriber

            currentUnsubscriber = await firestore.collection(`groups/${group}/robots`).onSnapshot(snapshot => {
                let currentLocations = [];
                snapshot.docs.forEach( doc => {
                    currentLocations.push(doc.data().position);
                })
                setCurrentLocations(currentLocations)
            });
        }

        //setup current location listener and unsubscriber
        generateCurrentLocationsListener()

        //Get map image and location data
        fetchMap()

        //Cleanup effect
        return () => {
            //TODO: Will: Only this subscriber is sometimes causing crashes due to not being defined
            // - should this protection exist elsewhere or did I do something wrong here?
            if (currentUnsubscriber !== undefined) {
                currentUnsubscriber()
            }
        }

    }, [group, locationDocs, videoNames])

    //When the map and all components to it are loaded, we can render
    useEffect(() => {
        if (map !== null && buttons !== null && currentLocations !== undefined && width !== 0 && height !== 0) {
            setIsReady(true)
        }
    }, [map, buttons, currentLocations, width, height, selectedBot])

    function drawLineWithArrows(x0,y0,x1,y1,aWidth,aLength,arrowStart,arrowEnd){
        var dx=x1-x0;
        var dy=y1-y0;
        var angle=Math.atan2(dy,dx);
        var length=25;//Math.sqrt(dx*dx+dy*dy);
        //
        var c = document.getElementById("locCanvas");
        var ctx = c.getContext("2d");
        ctx.translate(x0,y0);
        ctx.rotate(angle);
        ctx.beginPath();
        ctx.moveTo(0,0);
        ctx.lineTo(length,0);
        if(arrowStart){
            ctx.moveTo(aLength,-aWidth);
            ctx.lineTo(0,0);
            ctx.lineTo(aLength,aWidth);
        }
        if(arrowEnd){
            ctx.moveTo(length-aLength,-aWidth);
            ctx.lineTo(length,0);
            ctx.lineTo(length-aLength,aWidth);
        }

        ctx.stroke();
        ctx.setTransform(1,0,0,1,0,0);
    }

    const startLine= (e) =>{
        var offset = e.target.getBoundingClientRect();
        startX = e.clientX - offset.left
        startY = e.clientY - offset.top
        var c = document.getElementById("locCanvas");
        var ctx = c.getContext("2d");
        ctx.clearRect(0, 0, c.width, c.height);
        ctx.beginPath();
        ctx.arc(startX, startY, 5, 0, 2 * Math.PI);
        ctx.stroke();
    }

    const endLine = (e) =>{
        var offset = e.target.getBoundingClientRect();
        var x = e.clientX - offset.left
        var y = e.clientY - offset.top
        drawLineWithArrows(startX,startY,x,y,5,8,false,true)

        //EW: Had issue where the overlay canvas size and the map image size weren't the same so the map location
        //      calculation was off. Current fix is to keep a ref to the map image and get the size here that way.
        let mapWidth = offset.width
        let mapHeight = offset.height
        if (mapImgRef.current) {
            mapHeight = mapImgRef.current.offsetHeight;
            mapWidth = mapImgRef.current.offsetWidth;
        }

        const mapX = (startX/mapWidth) * width
        const mapY = (startY/mapHeight) * height
        const rawX = (((mapX - width/2.0) * -1) + width/2.0) * mapResolution + originX
        const rawY = mapY * mapResolution + originY

        var t = Math.atan2(y - startY,x - startX)
        if (t === 0) {
            t = 0.1
        }
        setPendingLocation({
            map: {
                x: mapX,
                y: mapY,
                theta: t
            },
            raw: {
                x: rawX,
                y: rawY,
                theta: t
            }
        })
        //Comment back in to restore auto scrolling functionality
        // if (buttonScrollRef.current) {
        //     buttonScrollRef.current.scrollIntoView({behavior: "smooth", block: "nearest", inline: "nearest"});
        // }

    }

    const preventDragHandler = (e) => {
        e.preventDefault();
    }

    function handleComponentOpen(open) {
        setComponentOpen(!open)
    }

    if (initialize) {
        return (
            <Box>
                <Paper>
                    <Box p={2}/>
                    <Typography variant="h1" gutterBottom>Map Initialization Required</Typography>
                    <Typography variant="body1" gutterBottom>To use the map, please follow the following
                        instructions on your Temi:</Typography>
                    <Box px={35}>
                        <ol>
                            <li>
                                <Typography variant="body1" align="left" gutterBottom>Navigate to the home screen by
                                    pressing the home button in the bottom left corner.</Typography>
                            </li>
                            <li>
                                <Typography variant="body1" align="left" gutterBottom>Click the "settings" button
                                    located on the left side of the screen</Typography>
                            </li>
                            <li>
                                <Typography variant="body1" align="left" gutterBottom>Click the "Send Map"
                                    button.</Typography>
                            </li>
                            <li>
                                <Typography variant="body1" align="left" gutterBottom>Refresh this
                                    page.</Typography>
                            </li>
                        </ol>
                        <Box p={2}/>

                    </Box>
                </Paper>
            </Box>
        )
    } else if (isReady) {
       const robotBoxes = []
       currentLocations.forEach(function (currentLocation, i) {
////            let color = "secondary"
//            let color = "#40c4ff"
//            let boldness = "body1"
//            if (botNames[i] === selectedBot) {
////                color = "primary"
//                color = "#76ff03"
//                boldness = "h4"
//            }
            if (currentLocation.x !== -1 && currentLocation.y !== -1 && currentLocation.theta !== -1) {
                //TODO: why doesn't setting color style work with a variable? Or overall how to define a color to use here in a better way
                if (botNames[i] === selectedBot) {
                    robotBoxes.push(
                        <Box className={classes.robotbox} key={botSerials[i]} position="absolute" top={(100 * currentLocation.y / height) + "%"} left={ (100 * currentLocation.x / width) + "%"}>
                            <Grid>
                                <Grid item><NatureIcon style={{color: theme.palette.custom.selectedBot}}/></Grid>
                                <Grid item>
                                    <Typography variant="h4" style={{color: theme.palette.custom.selectedBot}}>{botNames[i]}</Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    )
                } else {
                    robotBoxes.push(
                        <Box className={classes.robotbox} key={botSerials[i]} position="absolute" top={(100 * currentLocation.y / height) + "%"} left={ (100 * currentLocation.x / width) + "%"}>
                            <Grid>
                                <Grid item><NatureIcon style={{color: theme.palette.custom.otherBot}}/></Grid>
                                <Grid item>
                                    <Typography variant="body1" style={{color: theme.palette.custom.otherBot}}>{botNames[i]}</Typography>
                                </Grid>
                            </Grid>
                        </Box>
                    )
                }
            }
        });
        return (
            <Paper p={2} display={"flex"}>
                <Accordion expanded={componentOpen}>
                    <AccordionSummary  onClick={() => handleComponentOpen(componentOpen)}>
                        <Grid container direction="row"
                              justifyContent="space-between"
                              alignItems="center">
                            <Grid item>
                                <Typography variant="h1" color={'accordionHeader'}>Map</Typography>
                            </Grid>
                            <Grid item>
                                <IconButton size="small" onClick={() => handleComponentOpen(componentOpen)}>
                                    {componentOpen ? <KeyboardArrowUpIcon fontSize="large"/> :
                                               <KeyboardArrowDownIcon fontSize="large"/>}
                                </IconButton>
                            </Grid>
                        </Grid>
                    </AccordionSummary>
                    <AccordionDetails>
                        {/* Map */}
                        {/*TODO: change this to use theme spacing */}
                        <div style={{position:"relative", marginTop: '10px', marginLeft:'10px', marginRight:'10px'}}>
                            <img id="mapImg" src={map} onDragStart={preventDragHandler}  alt="Map" width="100%"  style={{zIndex:0, position:"relative"}} ref={mapImgRef}/>
                                {
                                    addingLocation && <canvas id={"locCanvas"} onMouseDown={startLine}  onMouseUp={endLine} width={mapImgRef.current.offsetWidth} height={mapImgRef.current.offsetHeight} style={{zIndex:1, backgroundColor:'rgba(52, 52, 52, 0.2)', position:"absolute", top:0, left:0}} />
                                }
                            <Box display="flex" position="absolute" top={"0%"} right={"0%"}>
                                <Button onClick={fetchMapAndRobot} sx={{minWidth:0}}>
                                    {/*Refresh Map*/}
                                    <RefreshIcon/>
                                </Button>
                            </Box>
                            {buttons}
                            {robotBoxes}
                        </div>

                        {/* Add Location Button */}
                        { addingLocation ?
                            <Grid item container p={1} spacing={3} xs={12}>
                                <Grid item container xs={7.5}>
                                        <TextField autoComplete='off' id="locationNameField" label="Location name..." fullWidth/>
                                    </Grid>
                                    <Grid item container justifyContent={'flex-end'} xs>
                                        <Button onClick={handleSubmitAddLocation} color="primary">
                                            Save this location
                                        </Button>
                                    </Grid>
                                    <Grid item container justifyContent={'flex-start'} xs={1.75}>
                                        <Button onClick={handleCancelAddLocation} color="primary">
                                            Cancel
                                        </Button>
                                    </Grid>
                                {/*<Box ref={buttonScrollRef}/>*/}
                            </Grid>
                            :
                            <Grid item p={1} xs={12}>
                                <Button onClick={handleAddLocation} color="primary">
                                    Add a location
                                </Button>
                            </Grid>
                        }

                        {/* Add Location Dialog */}
                        <Dialog
                            open={addInstructionsOpen}
                            onClose={handleCloseAddInstructions}
                        >
                            <DialogContent>
                                <DialogContentText>
                                    Click to select a position for your new location.
                                    If you would like your robot to face in a particular direction,
                                    click to select a position and drag in the direction you would
                                    like the robot to face.
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleCancelAddInstructions} color="primary">
                                    Cancel
                                </Button>
                                <Button onClick={handleCloseAddInstructions} color="primary">
                                    Okay
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </AccordionDetails>
                </Accordion>
            </Paper>
        )
    } else {
        return (
            <LoadingComponent/>
        )
    }
}

export default MapComponent